/**
 * NoActiveTicketCard - Shown when the user has no active ticket
 */

interface NoActiveTicketCardProps {
  myTicketLoading: boolean;
  onTakeTicket: () => void;
}

export function NoActiveTicketCard({ myTicketLoading, onTakeTicket }: NoActiveTicketCardProps) {
  return (
    <div className="bg-surface border border-hairline rounded-xl p-6 mb-6">
      <h2 className="font-sans text-xl font-semibold tracking-tight text-ink mb-4">Sacar Turno</h2>
      {myTicketLoading ? (
        <p className="text-ink-muted">Cargando…</p>
      ) : (
        <>
          <p className="text-sm text-ink-muted mb-4">
            No tienes ningún turno activo. Haz clic abajo para elegir sucursal, servicio y barbero.
          </p>
          <button
            onClick={onTakeTicket}
            className="w-full bg-accent text-on-accent px-6 py-3 rounded-lg hover:bg-accent-hover font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-focus"
          >
            Sacar Turno
          </button>
        </>
      )}
    </div>
  );
}
